module.exports = __webpack_public_path__ + "static/media/PathfinderHome_1920x1080.367fbfbd.png";